import Paginate from "../../../../components/pagination/paginate";
import AgentIcon from "../../../../icons/agentIcon";
import CircleExclamationIcon from "../../../../icons/circleExclaimationIcon";
import ShipmentDeliveredIcon from "../../../../icons/shipmentDeliveredIcon";
import ShipmentUpdateIcon from "../../../../icons/shipmentUpdateIcon";

const Notifications = () => {
  const notifications = [
    {
      title: "تحديث حالة الشحنة",
      message: "تم تحديث حالة الشحنة #ORDERID02 إلى 'في الميناء'",
      time: "1 PM",
      type: "shipment-updated",
    },
    {
      title: "تم تسليم الشحنة",
      message: "تم تسليم الشحنة #ORDERID01 بنجاح إلى العميل",
      time: "2 PM",
      type: "shipment-delivered",
    },
    {
      title: "لقد قام الوكيل بالرد عليك",
      message: "تم إستلام رد جديد من الوكيل",
      time: "3 PM",
      type: "agentReply",
    },
    {
      title: "تحديث النظام",
      message: "تم تحديث النظام إلى الإصدار الجديد v2.5",
      time: "4 PM",
      type: "system",
    },
    {
      title: "لقد قام الوكيل بالرد عليك",
      message: "تم إستلام رد جديد من الوكيل",
      time: "5 PM",
      type: "agentReply",
    },
  ];
  const handlePagination = () => {};
  const data = { last_page: 20 };

  return (
    <section className="space-y-5">
      {notifications.map((n, i) => {
        const color =
          n.type === "shipment-updated"
            ? "bg-[#EFF6FF]"
            : n.type === "shipment-delivered"
            ? "bg-[#F0FDF4]"
            : n.type === "agentReply"
            ? "bg-[#FEFCE8]"
            : n.type === "system"
            ? "bg-white"
            : "";
        const icon =
          n.type === "shipment-updated" ? (
            <ShipmentUpdateIcon />
          ) : n.type === "shipment-delivered" ? (
            <ShipmentDeliveredIcon />
          ) : n.type === "agentReply" ? (
            <AgentIcon />
          ) : n.type === "system" ? (
            <CircleExclamationIcon />
          ) : (
            ""
          );
        return (
          <div className={`flex gap-4 p-5 w-[70%] rounded-xl ${color}`}>
            <div>{icon}</div>
            <div>
              <h2 className="text-xl font-medium">{n.title}</h2>
              <p className="text-lg text-mainGray">{n.message}</p>
              <span className="text-[10px] text-mainGray">{n.time}</span>
            </div>
          </div>
        );
      })}
      <Paginate handlePagination={handlePagination} data={data} />
    </section>
  );
};

export default Notifications;
